import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";

export default class ImportPlayersDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          {languages.teams.importPlayers}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="caption">
              {languages.teams.importPlayersDescription}
            </Typography>
          </DialogContentText>
          <TextField
            multiline
            rows="12"
            onKeyDown={this.props.handleKeyDown}
            autoFocus
            margin="dense"
            label={languages.teams.listOfPlayers}
            value={this.props.playerList}
            name="playerList"
            onChange={this.props.handleChange}
            type="text"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSubmit}
            disabled={this.props.submitDisabled}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.general.save}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
} 